import { useContext } from "react";
import BundleFiltersContext from "core/context/BundleFiltersContext";

const useBundleFilters = () => {
  const context = useContext(BundleFiltersContext);

  if (context === undefined) {
    throw Error(
      "useBundleFilters must be used within a BundleFiltersProvider!"
    );
  }

  return context;
};

export default useBundleFilters;
